module.exports = __webpack_public_path__ + "img/galeria_stack_1.d0ffcdab.png";